import React, {useState, useEffect} from 'react';
import {Box, Flex, FormLabel, Textarea, Button} from '@chakra-ui/react';
import {CustomCheckbox, CustomInput, SubmitButton} from '../../components/General/FormInputs';
import {useForm} from 'react-hook-form';
import {useLocation, useNavigate} from 'react-router-dom';
import FlexCard from '../../components/General/FlexCard';
import {User} from '../../service/Urls';
import LoadingWheel from '../../components/General/LoadingWheel';
import {get, post} from '../../service/ApiService';
import ErrorHelper from '../../service/ErrorHelper';
import Roles from '../../constants/Roles';

import RoleList from '../../components/General/RoleList';
const UserAddEdit = props => {
  // can use useLocation to pass data behind the scenes to new routes, otherwise use props to pass to children elements, or url parameters
  const location = useLocation();
  const navigate = useNavigate();
  const [isUpdate, setIsUpdate] = useState(false);
  const [userData, setUserData] = useState({});
  const [userRoleIds, setUserRoleIds] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [toast, setToast] = useState(undefined);
  // const err = useError();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: {errors},
  } = useForm({defaultValues: userData});

  const loadData = async id => {
    const data = await get(User.USER + `/` + id);
    // Show error message if we can't get the main user data
    const onError = () => navigate(-1);
    setToast({response: data, onError: onError});

    if (!data.error) {
      // Set array of roles to pass to the rolelist component
      const roleIds = data.roles.map(role => role.name);
      setUserRoleIds(data.roles.map(role => role.name));
      // Set the prepopulated data then reset the form to get it to load
      setUserData(data);
      reset(data);
    }

    // Turn off the loading wheel since we're done loading
    setLoading(false);
  };

  useEffect(() => {
    // if we're updating
    if (location?.state?.id) {
      loadData(location?.state?.id);
      setIsUpdate(true);

      // if we're adding
    } else {
      setUserRoleIds([Roles.GRAYSTONE_DATA_ENTRY]);
      setLoading(false);
    }
  }, []);

  const resendRegistration = async () => {
    const response = await post(User.RESENT_UNLOCK_EML, `"${userData.id}"`);

    // Set the success message for the toast then the success function for the toast(which is just going back a page in history)
    const successMessage = 'Successfully resent registration to ' + userData.userName;
    const onSuccess = () => navigate(-1);
    setToast({response: response, successMessage: successMessage, onSuccess: onSuccess});
  };

  const updateUser = async data => {
    data.roles = data.roleList;
    console;
    if (data.roles.includes('ClientPersonnel') && data.clients.length === 0) {
      setToast({errorMessage: 'Please select at least one client', response: {error: true}});
      return;
    }
    let response = '';
    if (isUpdate) {
      response = await post(User.UPDATE, data);
    } else {
      response = await post(User.ADD, data);
    }

    // Set the success message for the toast then the success function for the toast(which is just going back a page in history)
    const successMessage = isUpdate ? 'Successfully updated ' + data.userName : 'Successfully added ' + data.userName;
    const onSuccess = () => navigate(-1);
    setToast({response: response, successMessage: successMessage, onSuccess: onSuccess});
  };

  return (
    <>
      {isLoading ? (
        <LoadingWheel />
      ) : (
        <form onSubmit={handleSubmit(updateUser)}>
          <Box flexDir={{base: 'column', lg: 'row'}} m="7" w="75%">
            <FlexCard>
              <Box>
                <Flex>
                  <CustomInput id="firstName" name="First Name" register={register} errors={errors} required />
                  <CustomInput id="middleName" name="Middle Name" register={register} errors={errors} />
                  <CustomInput id="lastName" name="Last Name" register={register} errors={errors} required />

                  <Flex alignItems={'end'} ml="5">
                    <CustomCheckbox id="isActive" name="Active" initial={isUpdate ? (userData?.isActive ? 1 : 0) : 1} control={control} />
                  </Flex>
                </Flex>

                <Flex>
                  <CustomInput id="userName" name="Username" register={register} errors={errors} required />
                  <CustomInput id="phoneNumber" name="Phone" register={register} errors={errors} />
                  <CustomInput id="email" name="Email" register={register} errors={errors} required isEmail />
                </Flex>
                <RoleList
                  checkedRoles={userRoleIds}
                  control={control}
                  errors={errors}
                  register={register}
                  setValue={setValue}
                  defaultClient={userData.clientId}
                  data={userData}
                />
                {isUpdate && (
                  <Button colorScheme={'secondary'} w="100%" onClick={() => resendRegistration()}>
                    Re-send user registration email
                  </Button>
                )}
              </Box>
            </FlexCard>
            <FlexCard>
              <Box w="100%">
                <FormLabel htmlFor="comments" mb="-0.5" ml="1" fontSize="sm">
                  Comment
                </FormLabel>
                <Textarea placeholder="Comment" id="comments" {...register('comments')} />
              </Box>
            </FlexCard>
            <SubmitButton name="Save" />
          </Box>
          <ErrorHelper toastResponse={toast} />
        </form>
      )}
    </>
  );
};

export default UserAddEdit;
